import { usePutSampleReportMutation } from 'app/services/samples';
import { Drawers } from 'app/types/drawer';
import { FieldProps, FieldType, DataForm } from 'components';
import { Sample } from 'constants/sample';

interface AddStatementProps {
  id: number;
  result?: boolean;
  statement?: string;
}

const AddStatement = ({ id, result, statement }: AddStatementProps) => {
  const [ putSampleReport, meta ] = usePutSampleReportMutation();

  const handleSubmit = async (value: any) => {
    const { Result, ResultStatement } = value;

    const statement = {
      Id: id,
      Result: Result === Sample.Result.OK,
      Statement: ResultStatement
    };

    await putSampleReport(statement);
  };

  const fields: FieldProps[] = [
    {
      name: 'ResultStatement',
      required: true,
      type: FieldType.TEXTAREA,
    },
    {
      name: 'Result',
      required: true,
      type: FieldType.SELECT,
      selectProps: {
        options: [ Sample.Result.OK, Sample.Result.NOK ],
      }
    },
  ];

  const initialValues = (typeof result === 'boolean') && statement ?
    {
      Result: result ? Sample.Result.OK : Sample.Result.NOK,
      ResultStatement: statement
    }
    : null;

  return <DataForm
    id={Drawers.ADD_STATEMENT}
    entity={'sample'}
    onSubmit={handleSubmit}
    fields={fields}
    meta={meta}
    initialValues={initialValues}
  />;
};

export default AddStatement;